import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=51a40d1a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"
import style0 from "./edit.vue?vue&type=style&index=0&id=51a40d1a&prod&lang=scss"
import style1 from "./edit.vue?vue&type=style&index=1&id=51a40d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a40d1a",
  null
  
)

export default component.exports